import _ from 'lodash';
import {formatDateTime} from '../../utils/utils';

export const formatIngestionDateTime = (value?: string | null) => {
  if (_.isEmpty(value)) return '--';

  const formatted = formatDateTime(value ?? undefined);
  return formatted === '—' ? '--' : formatted;
};
